import { render } from "./Menu4.vue?vue&type=template&id=4fd89d2b"
import script from "./Menu4.vue?vue&type=script&lang=js"
export * from "./Menu4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__